// extracted by mini-css-extract-plugin
module.exports = {"admonition":"Admonition_admonition__hZJtO","admonition--hasBorder":"Admonition_admonition--hasBorder__zewU5"};